/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { MySQL2Instrumentation } from './instrumentation';
export type {
  MySQL2InstrumentationConfig,
  MySQL2InstrumentationExecutionResponseHook,
  MySQL2ResponseHookInformation,
} from './types';
